import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import RegistrationForgotPassword from "./RegistrationForgotPassword.jsx";
import RegistrationLogIn from "./RegistrationLogIn.jsx";
import RegistrationSignUp from "./RegistrationSignUp.jsx";

import i18n from "../../i18n";
import { selectIsLoggedIn, setUser } from "../../store";
import currentUserApi from "../../api/currentUser";

export default function Registration({
  genderOptions,
  onBack,
  onNext,
  taskId,
}) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [showState, setShowState] = useState("register");
  const loggedIn = useSelector(selectIsLoggedIn);
  const dispatch = useDispatch();

  function goTo(where) {
    setError(null);
    setShowState(where);
  }

  function handleBackClick(event) {
    event.preventDefault();

    onBack();
  }

  useEffect(async () => {
    // Jump to next module if we are already signed in
    if (loggedIn) {
      onNext();
    } else {
      const data = await currentUserApi.get();
      dispatch(setUser(data));

      setLoaded(true);
    }
  }, []);

  if (!loaded) {
    return null;
  }

  let content = null;
  const headContent = (
    <Fragment>
      <h1 class="t-h6 t-h6--margin">
        {i18n.t("component.task_modules.registration.title")}
      </h1>
      <p class="t-body3 color-shades-charcoal mb-40">
        {i18n.t("component.task_modules.registration.description")}
      </p>
    </Fragment>
  );
  switch (showState) {
    case "forgotPassword":
      content = (
        <RegistrationForgotPassword
          onBack={handleBackClick}
          taskId={taskId}
          headContent={headContent}
          goTo={goTo}
        />
      );
      break;
    case "logIn":
      content = (
        <RegistrationLogIn
          onBack={handleBackClick}
          onNext={onNext}
          taskId={taskId}
          headContent={headContent}
          goTo={goTo}
          setError={setError}
          error={error}
          setEmail={setEmail}
          email={email}
        />
      );
      break;
    case "register":
      content = (
        <RegistrationSignUp
          genderOptions={genderOptions}
          onBack={handleBackClick}
          onNext={onNext}
          taskId={taskId}
          headContent={headContent}
          goTo={goTo}
          setError={setError}
          error={error}
          setEmail={setEmail}
          email={email}
          showInviteCode={taskId !== "pre_assessment"}
        />
      );
  }

  return <div class="task-module-registartion">{content}</div>;
}
